module.exports = {
  // JCRing成员页 越南
  JCRing_member: {
    //首页
    index1: "Sức khỏe thành viên",
    index2: "Nhóm sức khỏe",
    index3: "Thành viên",
    index4: "Thêm nhóm",
    index5: "Nhóm đã tham gia",
index6: "Cài đặt cảnh báo",
    index7: "Hãy để những người quan tâm đến sức khỏe của bạn quan tâm đến bạn nhiều hơn",
    index8: "Chưa tham gia nhóm",
    index9: "Trung tâm tin nhắn",
    index10: "Mời tham gia qua /điện thoại/ email/ mã QR/ Wechat",

    //创建群组
    addgroup1: "Tên nhóm",
    addgroup2: "Loại nhóm",
    addgroup3: "Vui lòng điền tên nhóm",
    addgroup4: "Nhóm gia đình",
    addgroup5: "Nhóm công ty",
    addgroup6: "Nhóm khác",
    addgroup7: "Nhóm y tế",
    addgroup8: "Nhóm trường học",
    addgroup9: "Xác nhận",
    addgroup10: "Hủy",
    addgroup11: "Tạo ngay",
    addgroup12: "Tên nhóm đã tồn tại",

    //成员列表
    memberlist1: "Danh sách thành viên",
    memberlist2: "Có",
    memberlist3: "Bất thường",
    memberlist4: "Bình thường",
    memberlist5: "Thêm thành viên",
    memberlist6: "Giải tán",
    memberlist7: "Chưa có thành viên",
    memberlist8: "Đang tải...",
    memberlist9: "Bạn có chắc muốn giải tán nhóm này？",
    memberlist10: "Giải tán thành công",
    memberlist11: "Lưu thành công",
    memberlist12: "Chỉnh sửa thông tin nhóm",
    memberlist13: "Giải tán nhóm",
    memberlist14: "Tổng quan sức khỏe",
    memberlist15: "Bình thường",
    memberlist16: "Bất thường",
    memberlist17: "Nhấp để xem",
    memberlist18: "Không có dữ liệu ngày hôm qua",
    memberlist19: "Ngày hôm qua",
    memberlist20: "Đã gửi",
    memberlist21: "lời mời tham gia nhóm, chờ xác nhận",

    //修改成员
    updatemember1: "Hình đại diện",
    updatemember2: "Thay đổi",
    updatemember3: "Tên Gốc",
    updatemember4: "Chỉnh sửa Tên",
    //健康数据,
healthdata1: "Dữ liệu sức khỏe",
healthdata2: "Dữ liệu sức khỏe",
healthdata3: "Chủ nhật",
healthdata4: "Thứ hai",
healthdata5: "Thứ ba",
healthdata6: "Thứ tư",
healthdata7: "Thứ năm",
healthdata8: "Thứ sáu",
healthdata9: "Thứ bảy",
healthdata10: "Nhịp tim",
healthdata11: "HRV",
healthdata12: "Huyết áp tâm thu",
healthdata13: "Huyết áp tâm trương",
healthdata14: "Sự thay đổi nhiệt độ",
healthdata15: "Độ bão hòa oxy trong máu",
healthdata16: "Giấc ngủ",
healthdata17: "Căng thẳng",
healthdata18: "Cholesterol",
healthdata19: "Triglycerides",
healthdata20: "Cholesterol LDL",
healthdata21: "Cholesterol HDL",
healthdata22: "Đường huyết",
healthdata23: "Trước bữa ăn",
healthdata24: "Sau bữa ăn",
healthdata25: "Vo2Max",
healthdata26: "Hô hấp",
healthdata27: "Số bước chân",
healthdata28: "Bước",
healthdata29: "Calo",
healthdata30: "Kcal",
healthdata31: "Khoảng cách",
healthdata32: "KM",
healthdata33: "tốc độ",
healthdata35: "S/KM",
healthdata36: "Min",
healthdata37: "đang tải dữ liệu sức khỏe",
healthdata38: "dữ liệu vận động",
healthdata39: "cảnh báo",
healthdata40: "không được cấp phép",
healthdata41: "sửa thông tin thành viên",
healthdata42: "xóa thành viên",
healthdata43: "Email:",
healthdata44: "điện thoại:",
healthdata45: "Bạn có muốn xóa thành viên này không?",
healthdata46: "Không thể hiển thị ngày trong tương lai",
healthdata47: "hôm nay",
    //邀请成员,
addmember1: "Mời thành viên",
addmember2: "Thêm tài khoản thành viên",
addmember4: "Thông qua 'Tài khoản thành viên', bạn có thể xem dữ liệu sức khỏe của thành viên và đặt phạm vi dữ liệu cảnh báo để theo dõi sức khỏe của thành viên tốt hơn",
addmember5: "Tìm hiểu thêm",
addmember6: "Thành viên nhóm sức khỏe",
addmember7: "Mời",
addmember8: "Tham gia",
addmember9: "Mời qua mã QR",
addmember10: "Mời qua WeChat",
addmember11: "Mời tham gia nhóm qua mã QR",
addmember12: "Mời tham gia nhóm qua WeChat",
addmember13: "Mời qua số điện thoại/email",
addmember14: "Mời tham gia nhóm qua số điện thoại/email",
addmember15: "Mời các thành viên tham gia để hiểu rõ tình trạng sức khỏe của họ",
addmember16: "Gửi lời mời",
addmember17: "Đã gửi",
addmember18: "Đang chờ xác nhận",
addmember19: "Tôi đã tham gia",
addmember20: "Chia sẻ ngay",
addmember21: "Lưu hình ảnh",
addmember22: "Tôi đã từ chối",
addmember23: "Tôi đã rời đi",
addmember24: "Bên kia đã rời đi",
addmember25: "Bên kia đã từ chối",
addmember26: "Bên kia đã tham gia",
addmember27: "Các phương pháp thêm khác",

    // 群组二维码,
code1: "Mã QR nhóm",
code2: "Nhóm quản lý sức khỏe",
code3: "Mã QR này có hiệu lực trong 5 phút, vui lòng sử dụng kịp thời",

    //群组邀请,
invide1: "Lời mời vào nhóm",
invide2: "Sức khỏe thành viên",
invide3: "Mời bạn tham gia nhóm...",
invide4: "Tham gia nhóm này",
invide5: "Để đảm bảo an toàn dữ liệu của bạn, chúng tôi đề nghị bạn kiểm tra thông tin nhóm trước khi tham gia",
invide6: "Sau khi tham gia nhóm, bạn sẽ cho phép người theo dõi xem dữ liệu sức khỏe của bạn",

    //分享健康数渶设置,
sethealthdata1: "Cài đặt dữ liệu sức khỏe",
sethealthdata2: "Xác nhận",
sethealthdata3: "Vui lòng đặt biệt danh",
sethealthdata4: "Cho phép tất cả",
sethealthdata5: "Đặt biệt danh",
sethealthdata6: "Lưu",
sethealthdata7: "Vui lòng nhập",
sethealthdata8: "Vui lòng tải lên định dạng hình ảnh",
sethealthdata9: "Vui lòng đặt biệt danh và hình đại diện",
sethealthdata10: "Vui lòng đặt hình đại diện",
sethealthdata11: "Độ dài biệt danh là 1-8 ký tự",

    // 设置数据区间,
setscope1: "Dải giới hạn nhịp tim",
setscope2: "Dải giới hạn nhiệt độ",
setscope3: "Dải giới hạn giấc ngủ",
setscope4: "Dải giới hạn nhịp tim thai nhi",
setscope5: "Đường huyết trước bữa ăn",
setscope6: "Đường huyết sau bữa ăn",
setscope7: "Dải giới hạn bão hòa oxy máu",
setscope8: "Axit uric nam giới",
setscope9: "Axit uric nữ giới",
setscope10: "Huyết áp tâm thu",
setscope11: "Huyết áp tâm trương",
setscope12: "Giới hạn trên",
setscope13: "Giới hạn dưới",
setscope14: "Thiết lập cảnh báo",
setscope15: "Thiết lập thành công",
setscope16: "Giới hạn trên",
setscope17: "Giới hạn dưới",
setscope18: "Cảnh báo",

    //下载页,
onload1: "Nhấp vào",
onload2: "Tham gia nhóm sức khỏe",
onload3: "Vui lòng mở bằng trình duyệt",
onload4: "Đã hiểu",
onload5: "Sức khỏe Yuhong, tận hưởng sức khỏe mỗi ngày",
onload6: "Tải xuống miễn phí từ App Store",
onload7: "Tải xuống miễn phí",
onload8: "Liên kết đã hết hạn",
onload9: "Mã QR đã hết hạn",
onload10: "Tham gia thành công",

    // （消息中心）待处理,
pending1: "Đồng ý",
pending2: "Từ chối",
pending3: "Gửi lại lời mời",
pending4: "Hiện không có dữ liệu",
pending5: "Lời mời đã được gửi, đang chờ người dùng đồng ý",
pending6: "Xác nhận",
pending7: "Thoát",

guide1: "Sau khi vào Sức khỏe thành viên, cần tạo loại nhóm tương ứng trước.",
guide2: "Sau khi tạo nhóm, bạn có thể vào nhóm để xem tổng quan sức khỏe của người dùng và mời thành viên mới tham gia nhóm.",
guide3: "Mời thành viên mới vào nhóm bằng cách quét mã, WeChat, số điện thoại / email và các phương thức khác. Sau khi thành viên mới tham gia nhóm, bạn có thể xem thông tin sức khỏe hàng ngày của họ.",
guide4: "Nhấp để xem tổng quan sức khỏe. Bạn có thể xem dữ liệu sức khỏe của thành viên và đánh giá xem chúng có bình thường hay không.",
guide5: "Bước tiếp theo",
guide6: "Hoàn thành",
guide7: "Vượt quá giá trị cảnh báo",

invite1: "Mời qua số điện thoại / email",
invite2: "Vui lòng nhập tài khoản",
invite3: "Vui lòng nhập số điện thoại",
invite4: "Vui lòng nhập email",
invite5: "Nhập số điện thoại chính xác",
invite6: "Nhập địa chỉ email chính xác",
invite7: "Đã tham gia nhóm này",
invite8: "Người dùng không tồn tại",
invite9: "Vui lòng chọn quốc gia hoặc khu vực",
invite10: "Vui lòng nhập từ khóa tìm kiếm",
invite11: "Xác nhận người dùng",
invite12: "Mời họ",
invite13: "Vui lòng chọn",


  },

   // AI H5页面
   JCRingAI: {
    index: "Xin chào,",
    index1: "Đây là thông tin sức khỏe hàng tuần của bạn.",
    index2: "Tuần",
    index3: "Tháng",
    index4: "Chỉ số sức khỏe",
    index5: "Chỉ số giấc ngủ",
    index6: "Chỉ số sinh lực",
    index7: "Chỉ số cân bằng",
    index8: "Ngày",
    index9: "Năm",
    index10: 'Những thông tin hàng tuần',
    index11: 'Những thông tin hàng tháng',
    index12: "Đây là thông tin sức khỏe hàng tháng của bạn.",

    sleep: 'Hồi phục giấc ngủ',
    sleep1: 'Xu hướng chỉ số giấc ngủ',
    sleep2: 'Xu hướng chỉ số giấc ngủ',
    sleep3: 'Chỉ số giấc ngủ là một chỉ số để đánh giá sức khỏe giấc ngủ của bạn, được tính toán dựa trên các chỉ số như tổng thời gian ngủ, hiệu quả giấc ngủ, thời gian để chìm vào giấc ngủ, nhịp tim khi ngủ, mức oxy khi ngủ và HRV, v.v.',
    sleep4: 'Chỉ số giấc ngủ của bạn là',
    sleep5: 'Tổng quan về giấc ngủ',
    sleep6: 'Thời lượng ngủ trung bình là',
    sleep7: 'Các giai đoạn của giấc ngủ',
    sleep8: 'Thời lượng trung bình',
    sleep9: 'Tỷ lệ phần trăm trung bình',
    
    sleep11: 'Giấc ngủ ngắn',
    sleep12: 'Thức giấc',
    sleep13: 'REM',
    sleep14: 'Ngủ nông',
    sleep15: 'Ngủ sâu',
    sleep16: 'Chiếm % trong tuần',
    sleep17: 'Tổng thời lượng giấc ngủ là',
    sleep18: 'Hiệu quả giấc ngủ trung bình là',
    sleep19: '%, Thời gian trung bình để đi vào giấc ngủ là',
    sleep20: 'min',
    sleep21: 'Thông tin về giấc ngủ',
    
    sleep22: 'Dữ liệu giấc ngủ được cải thiện',
    sleep23: 'Chỉ số giấc ngủ',
    sleep24: 'So với tuần trước',
    sleep25: 'Chỉ số giấc ngủ trung bình hàng tháng là',
    sleep26: 'Thời gian ngủ',
    sleep27: 'Thời gian để ngủ',
    sleep28: 'Thời gian trung bình để ngủ hàng tháng là',
    sleep29: 'Các lĩnh vực cần cải thiện',
    sleep30: 'Hiệu suất giấc ngủ',
    sleep31: 'Hiệu suất giấc ngủ trung bình hàng tháng là',
    sleep32: 'Cải thiện hiệu suất giấc ngủ như thế nào?',
    sleep33: 'Thông tin giấc ngủ hàng tháng',

    Expend: 'Hoạt động',
    Expend1: 'Xu hướng chỉ số hoạt động',
    Expend2: 'Xu hướng chỉ số hoạt động',
    Expend3: 'Chỉ số hoạt động là một chỉ số để đánh giá trạng thái tập luyện của bạn, được tính toán dựa trên các chỉ số khác nhau như số bước hàng ngày, khoảng cách, calo và khối lượng tập luyện.',
    Expend4: 'Chỉ số hoạt động trung bình hàng tuần là',
    Expend5: 'Tổng quan về hoạt động',
    Expend6: 'Số bước trung bình là',
    Expend7: ', khoảng cách trung bình là',
    Expend8:' km, calo là',
    Expend9: 'kcal',
    Expend10: 'Loại/Ngày',
    Expend11: 'Số bước',
    Expend12: 'Kcal',
    Expend13: 'Khoảng cách',
    Expend14: 'Bạn có 5 ngày để hoàn thành mục tiêu bước đi',
    Expend15: ', bạn có 5 ngày để hoàn thành mục tiêu calo',
    Expend16: ', bạn có 5 ngày để hoàn thành mục tiêu khoảng cách',
    Expend17: 'Thông tin hoạt động',
    
    Expend18: 'Chỉ số hoạt động',
    Expend19: 'Chỉ số hoạt động trung bình hàng tháng là',
    Expend20: 'Số bước trung bình',
    Expend21: 'Số bước trung bình hàng tháng là',
    Expend22: 'Lượng calo trung bình',
    Expend23: 'Lượng calo trung bình hàng tháng là',
    Expend24: 'Kcal',
    Expend25: 'Khoảng cách trung bình',
    Expend26: 'Khoảng cách trung bình hàng tháng là',
    Expend27: 'km',
    Expend28: 'Làm thế nào để cải thiện dữ liệu hoạt động?',
    Expend29: 'Thông tin hoạt động',

    Pressure: 'Cân bằng',
    Pressure1: 'Xu hướng chỉ số cân bằng',
    Pressure2: 'Xu hướng chỉ số cân bằng',
    Pressure3: 'Chỉ số cân bằng là chỉ số để đánh giá trạng thái căng thẳng của bạn, được tính toán dựa trên nhiều chỉ số khác nhau như căng thẳng hàng ngày, HRV, phản ứng căng thẳng và chỉ số phục hồi.',
    Pressure4: 'Chỉ số sinh lực trung bình là',
    Pressure5: 'Chỉ số cân bằng nhìn chung vẫn ổn định nhưng có sự biến động đáng kể, điều này có thể liên quan đến trạng thái cảm xúc của bạn. Nên học các kỹ thuật quản lý căng thẳng, như thiền và thở sâu, để điều chỉnh cảm xúc và duy trì sức khỏe thể chất và tinh thần.',
    Pressure6: 'Tổng quan về cân bằng',
    Pressure7: 'Căng thẳng trung bình là',
    Pressure8: 'Phản ứng căng thẳng trung bình là',
    Pressure9: 'Chỉ số phục hồi trung bình là',
    Pressure10: 'Căng thẳng',
    Pressure11: 'Phản ứng căng thẳng',
    Pressure12: 'Chỉ số phục hồi',
    Pressure13: 'Những hiểu biết về cân bằng',
  
    Pressure14: 'Dữ liệu cân bằng của bạn đã được cải thiện',
    Pressure15: 'Chỉ số cân bằng',
    Pressure16: 'Phản ứng căng thẳng hàng tháng là',
    Pressure17: 'Căng thẳng trung bình',
    Pressure18: 'Căng thẳng trung bình hàng tháng là',
    Pressure19: 'Cách giảm căng thẳng?',
    Pressure20: 'Những hiểu biết về cân bằng và phục hồi?',
    
    Health: 'Sức khỏe tim mạch',
    Health1: 'Xu hướng nhịp tim hàng tuần của bạn',
    Health2: 'Nhịp tim trung bình là',
    Health3: 'bpm',
    Health4: 'Xu hướng oxy trong máu hàng tuần của bạn',
    Health5: 'Mức oxy trong máu trung bình hàng tuần là',
    Health6: 'Nguy cơ tiểu đường hàng tuần của bạn',
    Health7: 'Đánh giá nguy cơ tiểu đường hàng tuần',
    Health8: 'Ngày',
    Health9: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
    
    Health10: 'Dữ liệu sức khỏe bình thường của bạn',
    Health11: 'Nhịp tim trung bình',
    Health12: 'Nhịp tim trung bình hàng tháng là',
    Health13: 'Mức SpO2 trung bình',
    Health14: 'Mức SpO2 trung bình hàng tháng là',
    Health15: 'Dữ liệu sức khỏe bất thường của bạn',
    Health16: 'Mức HRV trung bình',
    Health17: 'Mức HRV trung bình hàng tháng là',
    Health18: 'ms',
    Health19: 'Cách cải thiện HRV?',
    



}
};



// WEBPACK FOOTER //
// ./src/lang/vi.js